import { render } from "./LockReset.vue.js?vue&type=template&id=3477fab3!=!../vue-loader/dist/index.js??ruleSet[0]!./LockReset.vue?vue&type=template&id=3477fab3"
import script from "./LockReset.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./LockReset.vue?vue&type=script&lang=js"
export * from "./LockReset.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./LockReset.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__